const LIVE = "LIVE";
const Live = "Live";
const Play = "Play";
const Pause = "Pause";
const Mute = "Mute";
const Unmute = "Unmute";
const Subtitles = "Subtitles";
const en = {
  LIVE,
  Live,
  "Not Live": "Not Live",
  Play,
  Pause,
  Mute,
  Unmute,
  "Tap to unmute": "Tap to unmute",
  Subtitles,
  "Ad Playing": "Ad Playing",
  "Picture-in-Picture": "Picture-in-Picture",
  "Full screen": "Full screen",
  "Exit full screen": "Exit full screen",
  "Rewind 10 Seconds": "Rewind 10 Seconds",
  "Rewind Icon": "Rewind Icon",
  "Video Scrubber": "Video Scrubber",
  "Closed captions": "Closed captions",
  "Video Component Loading": "Video Component Loading"
};
export {
  LIVE,
  Live,
  Mute,
  Pause,
  Play,
  Subtitles,
  Unmute,
  en as default
};
//# sourceMappingURL=translation.json.js.map
